export enum OfferStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  BID = 'BID',
  BID_APPROVED = 'BID_APPROVED',
  DEFERRED = 'DEFERRED',
}
